// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1486":"77b5376c","6119":"8d6bb82a"}[chunkId] + ".chunk.css";
};